import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import ChatRecipeCreator from '../components/ChatRecipeCreator';

const CreateRecipe = () => {
  const navigate = useNavigate();
  const location = useLocation();
  
  // Determine where user came from - default to recipe-box, but if from /chats, go back there
  const handleBack = () => {
    // Check if there's a referrer state or if the previous path was /chats
    const fromChats = location.state?.from === 'chats' || 
                      document.referrer.includes('/chats') ||
                      window.history.state?.idx > 0;
    
    // Try to go back in history first, otherwise go to recipe-box
    if (window.history.length > 1) {
      navigate(-1);
    } else {
      navigate('/recipe-box');
    }
  };

  return <ChatRecipeCreator onBack={handleBack} />;
};

export default CreateRecipe;